import { default as Mui4Drawer } from '@material-ui/core/Drawer'
import { default as Mui5Drawer, DrawerProps as Mui5DrawerProps } from '@mui/material/Drawer'
import { forwardRef } from 'react'
import { useComponentVersion } from '../hooks/useComponentVersion'

import { DrawerContent } from '../other/drawer/DrawerContent'
import { BaseThemeType, useMediaQuery } from '../theme'

// Omit 'PaperProps.component' to avoid incompatible MUI4/MUI5 types
type PaperProps = Omit<Mui5DrawerProps['PaperProps'], 'component'>

export type DrawerProps = Omit<Mui5DrawerProps, 'PaperProps'> & {
  headerTitle?: string
  headerSubtitle?: string
  drawerContent?: React.ReactNode
  tagTitle?: string
  onTagClick?: () => void
  onClickHeaderIcon?: () => void
  badgeLabel?: string
  isFloating?: boolean
  PaperProps?: PaperProps
}

export enum OsDrawerVersion {
  V1 = 1, // MUI4 + OS Theme
  V2 = 2, // MUI5 + Stratis
}

export const Drawer = forwardRef<HTMLDivElement, DrawerProps>(({ children, PaperProps: paperProps, ...props }, ref) => {
  const version = useComponentVersion('drawer')
  const isMobile = useMediaQuery((theme: BaseThemeType) => theme.breakpoints.down(393))

  switch (version) {
    case OsDrawerVersion.V2:
      return (
        <Mui5Drawer
          {...props}
          ref={ref}
          sx={{
            ...props.sx,
            '& .OSUI-Paper-root': {
              maxWidth: 'calc(100% - 48px)',
              ...(props.isFloating && {
                margin: isMobile ? '16px' : '24px',
                height: isMobile ? 'calc(100% - 32px)' : 'calc(100% - 48px)',
                borderRadius: '8px',
                boxShadow: '0px 2px 16px 0px rgba(17, 17, 28, 0.08)',
              }),
            },
          }}
          PaperProps={paperProps}
        >
          {children || <DrawerContent {...props} />}
        </Mui5Drawer>
      )
    default:
      return (
        <Mui4Drawer {...props} ref={ref} PaperProps={paperProps}>
          {children || <DrawerContent {...props} />}
        </Mui4Drawer>
      )
  }
})
